module.exports = __webpack_public_path__ + "img/40_38_068_720.6ec1c53e.jpg";